import { useMemo } from 'react'

const useChatQuestionState = ({
  chatFlowType,
  effectiveAgentId,
  questionStep,
  getTranslatedOptions,
  newUserQuestionGates,
  existingUserQuestionGates,
  buttonStepIds,
  chatFlows,
}) => {
  const isExistingUser = chatFlowType
    ? chatFlowType === 'existing'
    : !!effectiveAgentId

  const questions = useMemo(
    () => (isExistingUser ? chatFlows.existingUser : chatFlows.newUser),
    [isExistingUser, chatFlows],
  )

  const hairTypeStep = useMemo(
    () =>
      chatFlows.newUser.find(
        (step) => step.id === 'hair_prediction_corrected_value',
      ),
    [chatFlows],
  )

  const questionGates = isExistingUser
    ? existingUserQuestionGates
    : newUserQuestionGates

  const lastInputStepIndex = useMemo(() => {
    for (let index = questions.length - 1; index >= 0; index -= 1) {
      const step = questions[index]

      if (
        step &&
        (step.type === 'text' || step.type === 'camera') &&
        step.id !== 'diagnosis' &&
        step.id !== 'recommendations' &&
        step.id !== 'eco_routine'
      ) {
        return index
      }
    }

    return -1
  }, [questions])

  const currentStepConfig =
    questionStep >= 0 && questionStep < questions.length
      ? questions[questionStep]
      : null

  const translatedCurrentStepOptions = currentStepConfig
    ? getTranslatedOptions(currentStepConfig)
    : []

  const translatedHairTypeOptions = getTranslatedOptions(hairTypeStep)

  const isPhotoStep = currentStepConfig?.type === 'camera'

  const isButtonStep =
    currentStepConfig?.type === 'buttons' ||
    currentStepConfig?.type === 'picture' ||
    (Array.isArray(currentStepConfig?.options) &&
      currentStepConfig.options.length > 0) ||
    buttonStepIds.has(currentStepConfig?.id)

  const isDone = questionStep >= questions.length

  return {
    isExistingUser,
    questions,
    hairTypeStep,
    questionGates,
    lastInputStepIndex,
    currentStepConfig,
    translatedCurrentStepOptions,
    translatedHairTypeOptions,
    isPhotoStep,
    isButtonStep,
    isDone,
  }
}

export default useChatQuestionState
